var React = require('react');

function Line24x2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1H23","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"}));
}

Line24x2.defaultProps = {"width":"24","height":"2","viewBox":"0 0 24 2","fill":"none"};

module.exports = Line24x2;

Line24x2.default = Line24x2;
